// extracted by mini-css-extract-plugin
export var aiStarIcon = "_uj-2";
export var container = "_uj-4";
export var dismissButton = "_uj-3";
export var hasPaddingBottom = "_uj-6";
export var last = "_uj-e";
export var scrollbarThumb = "_uj-c";
export var scrollbarTrack = "_uj-b";
export var selected = "_uj-9";
export var spin = "_uj-1";
export var spinning = "_uj-0";
export var suggestionItem = "_uj-d";
export var suggestionsPanel = "_uj-5";
export var tonePill = "_uj-8";
export var tonesContainer = "_uj-7";
export var unselected = "_uj-a";